// NPM Imports
import React, { Component, Fragment } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { Loader, Toastr, Button } from "@revvsales/components";

// Components Imports
import WFActions from "../WFActions";
import WFConditions from "../WFConditions";

// Actions Imports
import { WorkFlowActions } from "../../../actions";

// Internal Imports
import { AmplitudeUtils } from "../../../utils";
import { EVENTS, LOADING_MSG } from "../../../constants";

// Methods Imports
import { validateWorkFlowFields, generatePayloadForWorkFlow } from "./methods";

// Destructuring
const { getInitData, updateWorkFlowRule } = WorkFlowActions;

class ApprovalWrapper extends Component {
  static WorkFlowData = {};

  state = {
    showLoader: false,
    showButtonLoader: false,
  };

  componentDidMount() {
    this._onInit();
  }

  _toggleLoader = flag => {
    this.setState({ showLoader: flag });
  };

  _showToastr = (className, message) => {
    Toastr.showToastr({
      className,
      message,
      timeout: 2000,
    });
  };

  _onSubmit = () => {
    /**
     * * Copy trigger message from action to condition, this is done as temp due to UI difference
     * * in template & workflow page whereas for backend it the same
     */
    this.props.formFields.forEach(rule => {
      const {
        action: { triggerMessage },
        condition: { conditions },
      } = rule;
      if (triggerMessage) {
        conditions.forEach(condition => {
          condition.trigger_message = triggerMessage;
        });
      }
    });
    const isValid = validateWorkFlowFields(this.props.formFields);

    if (isValid) {
      const { rules } = this.props.data;
      const isEdit = rules && rules.every(rule => rule.id);
      const payload = generatePayloadForWorkFlow(
        this.props.formFields,
        this.props.metaData,
        this.props.data,
      );

      this.setState({ showButtonLoader: true });
      // Remove unwanted keys in case of add and make API
      this.props
        .updateWorkFlowRule(this.props.id, payload)
        .then(response => {
          const workflowData = {
            ...response[0],
          };
          this.setState({ showButtonLoader: false });
          this._showToastr(
            "is-success",
            isEdit
              ? "Your workflow conditions have been successfully updated."
              : "Your workflow conditions have been successfully saved.",
          );
          // Implementing Amplitude for workflow dt created
          const data = {};
          if (workflowData.rule_scopes && workflowData.rule_scopes.length > 0) {
            data.triggerLevel = workflowData.rule_scopes[0].object_type;
          }
          if (workflowData.conditions && workflowData.conditions.length > 0) {
            data.conditions = workflowData.conditions.length;
            data.triggerAttribute = workflowData.conditions[0].param;
          }
          if (workflowData.action && workflowData.action.data) {
            data.approvalOrder = workflowData.action.data.type;
          }
          if (
            workflowData.action &&
            workflowData.action.data &&
            workflowData.action.data.levels &&
            workflowData.action.data.levels.length > 0
          ) {
            data.approver =
              workflowData.action.data.levels[0].approvers.length ||
              workflowData.action.data.levels[0].group_approvers.length;
            if (
              workflowData.action.data.levels[0].group_approvers &&
              workflowData.action.data.levels[0].group_approvers.length > 0
            ) {
              data.approverType = "Grouped";
            } else if (
              workflowData.action.data.levels[0].approvers &&
              workflowData.action.data.levels[0].approvers.length > 0
            ) {
              data.approverType = "Individuals";
            }
          }
          if (workflowData.logical_op) {
            data.operationType = workflowData.logical_op;
          }

          AmplitudeUtils.amplitudeLogEvent(
            EVENTS.EVENT_NAMES.WORKFLOW_DT_CREATED,
            data,
          );
        })
        .catch(error => {
          this.setState({ showButtonLoader: false });
          console.error(
            `ApprovalWrapper => _onSubmit => updateWorkFlowRule => ${error}`,
          );
        });
    }
  };

  _onInit = () => {
    this._toggleLoader(true);
    this.props
      .getInitData(this.props.id)
      .then(() => {
        this._toggleLoader(false);
      })
      .catch(error => {
        console.error(`ApprovalWrapper => _onInit => ${error}`);
      });
  };

  render() {
    console.debug(this.state);
    const {
      data: { name: wfName, description: wfDescription },
    } = this.props;
    // Return the below component until API response is received
    if (this.state.showLoader) {
      return <Loader label={LOADING_MSG.WORKFLOW} />;
    }
    // Return the below component when loader is hidden
    return (
      <Fragment>
        {/* SECTION TO DISPLAY TOP TOOLBAR */}
        <div className="approvalwrapper-topbar">
          <div className="approvalwrapper-topbar-section">
            <div className="approvalwrapper-topbar-left">
              <Link to="/workflow">
                <div className="approvalwrapper-back-ico">
                  <FontAwesomeIcon icon={["far", "angle-left"]} />
                </div>
              </Link>
            </div>
            <div className="approvalwrapper-topbar-right">
              <span className="approvalwrapper-info-ico">
                <FontAwesomeIcon icon={["fad", "network-wired"]} />
              </span>
              <div className="approvalwrapper-topbar-info">
                <span className="approvalwrapper-topbar-title">{wfName}</span>
                <span className="approvalwrapper-topbar-subtitle">
                  {wfDescription}
                </span>
              </div>
              <div className="approvalwrapper-topbar-action">
                {/* <Button class="revv-btn-secondary">CANCEL</Button> */}
                <Button
                  onClick={this._onSubmit}
                  isLoading={this.state.showButtonLoader}
                  data-test="approvalwrapper-save-btn">
                  {this.props.data.rules ? "Update" : "Save"}
                </Button>
              </div>
            </div>
          </div>
        </div>
        {/* SECTION TO DISPLAY THE BODY */}
        <div className="approvalwrapper-body">
          <div className="approvalwrapper-scrollable">
            {Object.keys(this.props.data).length > 0 &&
              this.props.formFields.map((formField, index) => (
                <div className="approvalwrapper-split">
                  <div className="approvalwrapper-view">
                    <WFConditions data={formField.condition} index={index} />
                  </div>
                  <div className="approvalwrapper-view">
                    <WFActions
                      condition={formField.condition}
                      data={formField.action}
                      index={index}
                    />
                  </div>
                </div>
              ))}
          </div>
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = state => {
  const { workflowDetails: data, metaData, formFields } = state.WorkFlowStore;
  return {
    data,
    formFields,
    metaData,
  };
};

const mapDispatchToProps = {
  getInitData,
  updateWorkFlowRule,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ApprovalWrapper);



// WEBPACK FOOTER //
// ./src/components/WorkFlow/ApprovalWrapper/ApprovalWrapper.js